module.exports = __webpack_public_path__ + "img/f60eb0b.png";